import { Modal as AntModal } from "antd";

const Modal = ({ children, show, onCancel, title, ...props }) => {
  return (
    <AntModal
      maskClosable={false}
      closable
      footer={null}
      open={show}
      onCancel={onCancel}
      title={title}
      {...props}
    >
      {title && <hr />}
      {children}
    </AntModal>
  );
};

export default Modal;
